export function wordChars(name: string): string {
  return name.replace(/\W/g, "");
}

